// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".treeView--1icTwset {\n  white-space: nowrap;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.treeWrapper--1nWKnoj_ {\n  padding: 0 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"treeView": "treeView--1icTwset",
	"treeWrapper": "treeWrapper--1nWKnoj_"
};
export default ___CSS_LOADER_EXPORT___;
